// ---------------------------------------------------------------
// Sita — site-wide content constants.
// Everything Ashley needs to swap lives in this one file.
// ---------------------------------------------------------------
import sitaLogo from "../assets/sita-logo.png";
import wordmarkCream from "../assets/sita-wordmark-cream.png";
import wordmarkInk from "../assets/sita-wordmark-ink.png";
import wordmarkAmber from "../assets/sita-wordmark-amber.png";
import leafSet1 from "../assets/leaf-set-1.png";
import leafSet2 from "../assets/leaf-set-2.png";
import leafSet3 from "../assets/leaf-set-3.png";
import leafSet4 from "../assets/leaf-set-4.png";
import realSalad from "../assets/real-salad.jpeg";
import realDesserts from "../assets/real-desserts.jpeg";
import realMealprep from "../assets/real-mealprep.jpeg";
import realProduce from "../assets/real-produce.jpeg";
import realMomos from "../assets/real-momos.jpeg";
import realTable from "../assets/real-table.jpeg";
import realGrazing from "../assets/real-grazing.jpeg";
import realWaffles from "../assets/real-waffles.jpeg";
import catToast from "../assets/cat-toast.jpeg";
import catFigsalad from "../assets/cat-figsalad.jpeg";
import catDosa from "../assets/cat-dosa.jpeg";
import catNoodles from "../assets/cat-noodles.jpeg";
import catFarro from "../assets/cat-farro.jpeg";
import scMenu from "../assets/sc-1.jpeg";
import scRoom from "../assets/sc-2.jpeg";
import scCocktails from "../assets/sc-5.jpeg";
import scCooking from "../assets/sc-3.jpeg";
import scPlate from "../assets/sc-4.jpeg";
import scMingle1 from "../assets/sc-mingle1.jpeg";
import scMingle2 from "../assets/sc-mingle2.jpeg";
import scHallway from "../assets/sc-hallway.jpeg";
import homeCheesecake from "../assets/home-cheesecake.webp";
import brandedTable from "../assets/branded-table.webp";

export const ASSETS = {
  sitaLogo,
  wordmarkCream,
  wordmarkInk,
  wordmarkAmber,
  leafSet1,
  leafSet2,
  leafSet3,
  leafSet4,
};

export const SITE = {
  name: "Sita",
  tagline: "earth found, home cooked.",
  // Stan Store — storefront link (SWAP for an event-specific ticket link when one is created)
  stanStoreUrl: "https://stan.store/Sita_Earthfound",
  // Real Instagram profile (from @sita_earthfound)
  instagramUrl: "https://www.instagram.com/sita_earthfound",
  // Real per-seat price for the monthly supper club ($65) — kept internal, not shown on the site
  seatPrice: "$65",
  // SWAP: real deposit amount that holds a private date
  depositAmount: "$50",
  // SWAP: when the balance is due (e.g. "7 days")
  balanceDue: "7 days",
  locationLine: "Sita · Supper club, catering & private chef · Jersey City, NJ.",
};

// Placeholder natural-light photography (Ashley swaps in real photos later)
const u = (id) => `https://images.unsplash.com/${id}?q=85&w=1600&auto=format&fit=crop`;
const p = (id) => `https://images.pexels.com/photos/${id}/pexels-photo-${id}.jpeg?auto=compress&cs=tinysrgb&w=1400`;

export const IMG = {
  homeHero: u("photo-1580738204555-8686f3a2db43"), // aerial green field — the essence backdrop
  homeAbout: realSalad, // real: fig, endive & pistachio platter
  cardSupperClub: u("photo-1688437307687-fe226bddfab1"), // candlelit table set with plates
  cardCatering: realGrazing, // real: grazing spread
  cardPrivate: p(7262349), // cooking at a sunlit counter
  proofA: realMomos, // real: dumplings plated by candlelight
  proofB: homeCheesecake, // real: mango cheesecake cups
  proofC: realWaffles, // real: savory waffles with chutneys
  supperClubHero: scMenu, // real: the night's menu card — "Welcome Rudransh"
  supperClubRoom: scRoom, // real: the club in session, eight guests around the table
  supperClubCocktails: scCocktails, // real: first pour — amber cocktails
  supperClubCooking: scCooking, // real: dosa waffles being made in the quiet kitchen
  supperClubPlate: scPlate, // real: a loaded plate, mid-supper-club
  supperClubMingle1: scMingle1, // real: guests by the gallery wall
  supperClubMingle2: scMingle2, // real: conversation over first pours
  supperClubHallway: scHallway, // real: the doorway into the set table
  cateringHero: catToast, // real: farro salad close-up (full-bleed, label crops away)
  cateringSide: catFigsalad, // real: cold noodles — cucumber, sesame, chili broth
  menuDosa: catDosa, // real: dosa waffles with house chutneys
  menuNoodles: catNoodles, // real: fig & endive salad — figs, endive, olives, pistachio
  menuFarro: catFarro, // real: brioche toast with whipped filling + strawberries
  privateHero: brandedTable, // real: the branded Sita table set for an event
  privateSpace: realTable, // real: guests gathered in the Sita space
  privateHosting: realMomos, // real: candlelit dumplings from a hosted night
  privateMealPrep: realMealprep, // real: Sita meal prep containers
  privateChef: u("photo-1760445529215-6fedada394cd"), // chef chopping board
  aboutSoil: realProduce, // real: market haul — peppers, squash, greens
  aboutKitchen: p(7262349), // quiet kitchen
  aboutFood: p(6111928), // nourishing plate
  aboutTable: u("photo-1536392706976-e486e2ba97af"), // the long table
};

export const INTEREST_OPTIONS = [
  "A seat at the monthly supper club",
  "Hosting a private event in the Sita space",
  "Guest chef night",
  "Catering",
  "In-home meal prep",
  "Personal chef services",
  "Something else",
];
